import awsAnalyticsRecorder from "./awsAnalyticsRecorder";
import {AnalyticsEvent} from "../declarations/analyticsEvent";
import googleAnalyticsRecorder from "./googleAnalyticsRecorder";

const wrapper = (event: AnalyticsEvent): void => {
    awsAnalyticsRecorder(event);
    googleAnalyticsRecorder(event);
};

export default wrapper;